import { put } from 'redux-saga/effects'
import axios from '../../axios-conf'
import uris from '../../uris'
import {
  organizationLoadSuccess,
  organizationLoadFailure,
  organizationSaveSuccess,
  organizationSaveFailure,
  redirect,
  addNotification
} from '../actions'
import { uiConstants } from '../../constants'
import { uiHelper } from '../../helpers'

export function* organizationLoadSaga() {
  try {
    const result = yield axios.get(uris.organization)
    yield put(organizationLoadSuccess(result.data))
  } catch (error) {
    yield put(addNotification(uiHelper.errorMessage(error), true))
    yield put(organizationLoadFailure(uiHelper.errorMessage(error)))
  }
}

export function* organizationSaveSaga(action) {
  try {
    const body = { ...action.payload }
    let url = uris.organization
    let method = 'post'
    if (action.payload.id) {
      url += `/${action.payload.id}`
      method = 'patch'
    }
    delete body.id
    const result = yield axios({
      method,
      url,
      data: body
    })
    yield put(organizationSaveSuccess(result.data))

    if (!action.payload.id) {
      yield put(redirect(`/${result.data._id}/dashboard`))
    }
    yield put(
      addNotification(
        action.payload.id
          ? uiConstants.messages.organization_updated
          : uiConstants.messages.organization_created
      )
    )
  } catch (error) {
    yield put(addNotification(uiHelper.errorMessage(error), true))
    yield put(organizationSaveFailure(uiHelper.errorMessage(error)))
  }
}

export function* organizationJoinSaga(action) {
  try {
    const result = yield axios.patch(uris.organizationJoin, action.payload)
    yield put(organizationSaveSuccess(result.data))
    yield put(redirect(`/${result.data._id}/dashboard`))
    yield put(addNotification(uiConstants.messages.organization_joined))
  } catch (error) {
    yield put(addNotification(uiHelper.errorMessage(error), true))
    yield put(organizationSaveFailure(uiHelper.errorMessage(error)))
  }
}
